module.exports = __webpack_public_path__ + "static/20251018_152658-127daebeeaa91ccc766f45f025b44203.jpg";